import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadSoftwareFeeReport, exportSoftwareFeeReport } from './actions';
import { initialize } from 'redux-form';
import utils from '../../../common/services/utils';

class SoftwareFeeReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const { currentYear, currentMonth } = this.props;

		const filter = { year: currentYear, month: currentMonth };
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleFilterSubmit(options) {
		const { exportFormat, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (exportFormat)
			this.exportData(filter, exportFormat);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	exportData(filter, exportFormat) {
		this.props.exportReport(exportFormat, filter);
	}

	render() {
		const { data, months, years, currentMonth, currentYear, offerWorkshops, stripeApplicationFeeRate } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					months={months}
					years={years}
					initialValues={{ month: currentMonth, year: currentYear }}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					offerWorkshops={offerWorkshops}
					useStripeFeeMode={stripeApplicationFeeRate > 0}
					onFetchData={this.handleListEvent}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {

	const {
		pagination,
		exports,
		lookups: { years, months },
		entities: { softwareFeeReport },
		configuration: { franchisor }
	} = state;

	const softwareFeeReportPagination = pagination.softwareFeeReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const softwareFeeReportExport = exports.softwareFeeReport.all || {};

	return {
		data: softwareFeeReportPagination.ids.map(id => softwareFeeReport[id]),
		pagination: softwareFeeReportPagination,
		export: softwareFeeReportExport,
		months,
		years,
		currentMonth: utils.getCurrentMonth(),
		currentYear: utils.getCurrentYear(),
		offerWorkshops: franchisor.offerWorkshops,
		stripeApplicationFeeRate: franchisor.stripeApplicationFeeRate
	};
};

const mapDispatchToProps = {
	loadReport: loadSoftwareFeeReport,
	exportReport: exportSoftwareFeeReport,
	resetFilter: () => reset('softwareFeeReportFilter'),
	initializeFilter: (data, fields) => initialize('softwareFeeReportFilter', data, fields)
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SoftwareFeeReport));